import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class HolidaysStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}

